import { Constants } from '../_constants/shared.constants';
export const  success=(data)=> {
     return{ type: Constants.container.CONTAINER_SUCCESS,data }
     }
export const  error=(data)=> { 
    return{ type: Constants.container.CONTAINER_FAILURE,data }
 }